// Shared rules for the recipients of an outbound Chatwoot email reply.
// Imported by both the frontend composer (via the src/lib/shared symlink) and
// the Cloud Function, so the operator is told about a bad address while they can
// still fix it, rather than after the send fails.

// Addresses an operator types by hand. A runaway list is a mistake, not a use
// case, and each entry is an email we would send on their behalf.
export const MAX_OUTBOUND_RECIPIENTS = 25

// Deliberately permissive, and NOT the authority. Chatwoot validates every
// address against Ruby's URI::MailTo::EMAIL_REGEXP and fails the whole send if
// one is bad, so the server is what decides. This check exists to catch the
// obvious typo in the composer; being stricter than Chatwoot here would block
// addresses it would happily accept, which is the worse failure of the two.
const LOOKS_LIKE_EMAIL = /^[^\s@,]+@[^\s@,]+\.[^\s@,]+$/

export function isLikelyEmailAddress(value: string): boolean {
  return LOOKS_LIKE_EMAIL.test(value.trim())
}

// Trim, drop blanks, and de-duplicate case-insensitively while keeping the
// operator's own order and original casing. Chatwoot splits these back out of a
// comma-joined string, so an embedded comma would silently become two
// recipients — such entries are dropped rather than sent somewhere unintended.
export function normalizeRecipients(values: readonly string[]): string[] {
  const seen = new Set<string>()
  const result: string[] = []
  for (const raw of values) {
    const trimmed = raw.trim()
    if (!trimmed || trimmed.includes(',')) {
      continue
    }
    const key = trimmed.toLowerCase()
    if (seen.has(key)) {
      continue
    }
    seen.add(key)
    result.push(trimmed)
  }
  return result
}
